import { useQuery } from '@tanstack/react-query';

import { authFetch } from '@verantos-dev/core-utils';
import type { ObjectResponse } from '@verantos-dev/types-common';

import { analysisKeys } from './queryKeys';
import type { AnalysisVersion } from './types';

interface UseAnalysisVersionQueryArgs {
  projectId: string;
  analysisProfileId: string;
  analysisVersionId: string;
}

export const useAnalysisVersionQuery = ({
  projectId,
  analysisProfileId,
  analysisVersionId,
}: UseAnalysisVersionQueryArgs) => {
  return useQuery({
    queryKey: analysisKeys.version(analysisVersionId),
    queryFn: () =>
      authFetch<ObjectResponse<AnalysisVersion>>(
        `/analyses/${encodeURIComponent(projectId)}` +
          `/analysis-profile/${encodeURIComponent(analysisProfileId)}` +
          `/analysis-version/${encodeURIComponent(analysisVersionId)}`
      ),
    enabled: projectId.length > 0 && analysisProfileId.length > 0 && analysisVersionId.length > 0,
    retry: false,
  });
};
